import React from "react";

// Card Header
export const CardHeader = ({ title, subtitle, icon: Icon, className = "" }) => (
  <div className={`text-center mb-6 ${className}`}>
    {Icon && <Icon className="w-12 h-12 text-brand-gold-ink mx-auto mb-3" />}
    <h3 className="text-lg font-display font-bold text-brand-charcoal">{title}</h3>
    {subtitle && <p className="text-brand-muted break-words">{subtitle}</p>}
  </div>
);

export default CardHeader;
